import ProductContainer from '../src/containers/Product';

export default ProductContainer;
